module.exports = __webpack_public_path__ + "img/c.99df215f.jpg";